import PropTypes from 'prop-types';
import PanelCloseButton from './panelCloseButton';

export default function PanelHeader({ children, closeButton, title }) {
  return (
    <div className="sidebar-panel-header u-margin-xl-bottom u-clr-grey7">
      <span className="sidebar-panel-header-title u-display-inline-block text-s">{title}</span>
      {children}
      {closeButton}
    </div>
  );
}

PanelHeader.propTypes = {
  children: PropTypes.node,
  closeButton: PropTypes.element,
  title: PropTypes.node.isRequired,
};

PanelHeader.defaultProps = {
  children: undefined,
  closeButton: <PanelCloseButton />,
};
